import React, { useRef, useState } from 'react';
import styles from './ApplicationsTableTopHeader.module.css';
import SearchInput from '../../Atoms/Inputs/SearchInput';
import MoreButton from '../Custom/MoreButton';
import exportICon from '../../../assets/Imagess/exportIcon.svg';
import printicon from '../../../assets/Imagess/printIcon.svg';
import moreicon from '../../../assets/Imagess/moreicon.svg';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import TableToPrint from '../../Molecules/Applications/TableToPrint';

const TableTopHeader = ({
  mode,
  search,
  setSearch,
  refetch,
  handleExport,
  data,
  tableHeader,
  title,
  /* The research registry carries its own export control, which knows about
     the current selection and whether attachments are wanted. Two buttons
     doing almost-the-same thing is worse than either alone, so that screen
     drops this one and keeps طباعة. */
  hideExport = false,
}) => {
  let componentRef = useRef();
  const handleSearch = (searchText) => {
    setSearch(searchText);
  };

  /**
   * Page setup for the printed table.
   *
   * This lives here rather than in `ApplicantsTable.module.css` because `@page`
   * is NOT scoped by CSS modules — a rule there is global, and would turn every
   * other print in the CMS landscape too, including the portrait detail boxes.
   * `pageStyle` is injected for this print job only.
   *
   * LANDSCAPE because these tables run to seven columns: in portrait, A4 gives
   * each column about 24mm, which wraps an Arabic research title to four or
   * five lines and pushes a twenty-row table onto three sheets.
   *
   * The margins leave a 16mm foot, which is where browsers place the page
   * number and the date they add themselves.
   *
   * `print-color-adjust` asks the browser to keep the one colour the document
   * relies on — the rule under the heading. Everything else is designed to
   * survive being dropped, because background printing is off by default and
   * an operator cannot be expected to find that setting.
   */
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: title,
    pageStyle: `
      @page {
        size: A4 landscape;
        margin: 14mm 12mm 16mm;
      }
      @media print {
        html, body {
          height: auto;
          background: #fff;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      }
    `,
  });
  return (
    <>
      <div className={styles['icon-container']}>
        <div>
          <SearchInput search={search} setSearch={handleSearch} />
        </div>

        <div className={styles['icon-subcontainer']}>
          <MoreButton icon={moreicon} left="0">
            <div className="profile-container">
              {hideExport ? null : (
                <div onClick={handleExport}>
                  <img src={exportICon} alt="profile" /> <h4>تصدير </h4>{' '}
                </div>
              )}
              <div onClick={handlePrint}>
                <img src={printicon} alt="profile" /> <h4>طباعة </h4>{' '}
              </div>
            </div>
          </MoreButton>
        </div>
      </div>

      <div style={{ display: 'none' }}>
        <TableToPrint
          data={data}
          mode={mode}
          tableHeader={tableHeader}
          ref={componentRef}
          title={title}
        />
      </div>
    </>
  );
};

export default TableTopHeader;
